import { ColorPicker, Input, InputNumber, Select } from "antd";
import styled from "styled-components";
export const StyledFormInputs = styled(Input)`
    height: 38px;
`;

export const StyledColorPicker = styled(ColorPicker)`
    .ant-color-picker-color-block{
      width: 100%;
    }
`;

export const StyledFormInputNumber = styled(InputNumber)`
    height: 38px;
`;

export const StyledFormSelect = styled(Select)`
    height: 38px;
    .ant-select-item-option{
      font-weight: bold;
    }
    .ant-select-item-option-content{
      font-weight: bold;
    }
`;
export const StyledOption = styled(Select.Option)`
    font-weight: bold;
    font-size: 40px;
  .ant-select-item-option{
    font-weight: bold;
  }
  .ant-select-item-option-content{
    font-weight: bold;
  }
`;
